import React from 'react';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';
import TituloDeckTablonWpc from '../components/sections/DeckTablonWpc/TituloDeckTablonWpc';
import IntroDeckTablonWpc from '../components/sections/DeckTablonWpc/IntroDeckTablonWpc';
import CaracteristicasDeckTablonWpc from '../components/sections/DeckTablonWpc/CaracteristicasDeckTablonWpc';
import MaterialDeckTablonWpc from '../components/sections/DeckTablonWpc/MaterialDeckTablonWpc';
import ColoresDeckTablonWpc from '../components/sections/DeckTablonWpc/ColoresDeckTablonWpc';
import GaleriaDeckTablonWpc from '../components/sections/DeckTablonWpc/GaleriaDeckTablonWpc';
import FormularioContactoDeckTablonWpc from '../components/sections/DeckTablonWpc/FormularioContactoDeckTablonWpc';

const DeckTablonWpc = () => {
  return (
    <div>
      <Header />
      <TituloDeckTablonWpc />
      <MaterialDeckTablonWpc />
      <GaleriaDeckTablonWpc />
      <ColoresDeckTablonWpc />
      <CaracteristicasDeckTablonWpc />
      <FormularioContactoDeckTablonWpc />
      <Footer />
    </div>
  );
};

export default DeckTablonWpc;